import { render, staticRenderFns } from "./addInsecurityEvent.vue?vue&type=template&id=9d9ab64a&scoped=true"
import script from "./addInsecurityEvent.vue?vue&type=script&lang=js"
export * from "./addInsecurityEvent.vue?vue&type=script&lang=js"
import style0 from "./addInsecurityEvent.vue?vue&type=style&index=0&id=9d9ab64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9ab64a",
  null
  
)

export default component.exports